const LoadingScreen = () => {
  return (
    <div
      className="fixed inset-0 z-[9999] flex flex-col items-center justify-center"
      style={{ background: "var(--vi-page)" }}
      data-testid="loading-screen"
    >
      {/* Ambient glow behind logo */}
      <div
        className="absolute rounded-full blur-[80px] opacity-30"
        style={{
          width: 240,
          height: 240,
          background: "radial-gradient(circle, #8b5cf6 0%, #06b6d4 60%, transparent 100%)",
        }}
      />

      {/* Animated logo icon */}
      <div className="relative animate-fade-in-up">
        <div
          className="relative flex items-center justify-center rounded-2xl animate-loading-breathe"
          style={{
            width: 88,
            height: 88,
            background: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 40%, #06b6d4 100%)",
            boxShadow: "0 0 40px rgba(99, 102, 241, 0.25), 0 0 80px rgba(6, 182, 212, 0.15)",
          }}
        >
          <svg width={56} height={56} viewBox="0 0 48 48" fill="none">
            {/* Brain outline */}
            <path
              d="M24 6C18.5 6 14 9.5 13 14C10.5 14.5 8 17 8 20.5C8 23 9 25 10.5 26.5C9.5 28 9 30 9 32C9 36 12 39 16 39.5C17 41.5 19.5 43 22.5 43C23 43 23.5 42.95 24 42.9M24 6C29.5 6 34 9.5 35 14C37.5 14.5 40 17 40 20.5C40 23 39 25 37.5 26.5C38.5 28 39 30 39 32C39 36 36 39 32 39.5C31 41.5 28.5 43 25.5 43C25 43 24.5 42.95 24 42.9M24 6V42.9"
              stroke="white"
              strokeWidth="2.2"
              strokeLinecap="round"
              strokeLinejoin="round"
              opacity="0.85"
            />
            {/* Animated waveform */}
            <path
              className="animate-path-draw"
              d="M16 24L18 20L20 28L22 18L24 30L26 16L28 28L30 20L32 24"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>

        {/* Sound wave rings */}
        {[0, 1, 2].map((i) => (
          <div
            key={i}
            className={`absolute inset-0 rounded-2xl animate-loading-ring animate-loading-ring-${i + 1}`}
            style={{ border: "1px solid rgba(139, 92, 246, 0.3)" }}
          />
        ))}
      </div>

      {/* Text */}
      <div className="mt-8 flex items-baseline gap-2 animate-fade-in-up" style={{ animationDelay: "0.4s" }}>
        <span
          className="font-heading text-2xl font-bold tracking-tight"
          style={{
            background: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 40%, #06b6d4 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
          }}
        >
          Audio
        </span>
        <span
          className="font-heading text-2xl font-bold tracking-tight"
          style={{ color: "var(--vi-text)" }}
        >
          Ideias
        </span>
      </div>

      {/* Subtle loading dots */}
      <div className="mt-6 flex items-center gap-1.5 animate-fade-in-up" style={{ animationDelay: "0.8s" }}>
        {[0, 1, 2].map((i) => (
          <div
            key={i}
            className={`w-1.5 h-1.5 rounded-full animate-loading-dot animate-loading-dot-${i + 1}`}
            style={{ background: "#8b5cf6" }}
          />
        ))}
      </div>
    </div>
  );
};

export default LoadingScreen;
